import { FC } from "react";

import { hasReadiedUsersReachedMaxGroupSize } from "components/materials/page/groups/helpers";
import { PageType } from "components/server-types";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { PillButton } from "mds/components/PillButton";
import { PersonGroupIcon } from "mds/icons";
import { storeApi, useAppSelector } from "store/index";
import { selectCurrentSectionUserId, selectNestedPageGroupForUser } from "store/selectors";

interface ConfirmGroupButtonProps {
  selectedPage: PageType;
  userId: string;
}

export const ConfirmGroupButton: FC<ConfirmGroupButtonProps> = ({ selectedPage, userId }) => {
  const pageGroup = useAppSelector((s) =>
    selectNestedPageGroupForUser(s, selectedPage?.id, userId),
  );
  const sectionUserId = useAppSelector(selectCurrentSectionUserId);
  const pageGroupUser = pageGroup?.page_group_users.find(
    (pgu) => pgu.section_user_id === sectionUserId,
  );
  const isDisabled = !pageGroup || hasReadiedUsersReachedMaxGroupSize(pageGroup, selectedPage);

  const onConfirmGroup = async () => {
    if (!pageGroupUser) return;
    await storeApi.page_group_users.partial_update({
      id: pageGroupUser.id,
      is_ready: true,
    });
  };

  return (
    <PillButton
      disabled={isDisabled}
      eventName="Student Page - Confirm Group"
      eventProps={{ pageTitle: selectedPage.title, pageId: selectedPage.id }}
      kind="green"
      size="m"
      onClick={onConfirmGroup}
    >
      <IconText iconStart={<PersonGroupIcon />} text={t("page_view.confirm_group")} />
    </PillButton>
  );
};
